import { render } from "./UserSettings.vue?vue&type=template&id=3ea9cc1a&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=3ea9cc1a&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__